export default __webpack_public_path__ + "static/media/Real_Estate_Information.9576e63a.pdf";